export const INVOICES_QUERY_SEARCH_PARAM_KEY = 'invoiceQuery';
